import React from "react";

import { useSubscriptionContext } from "../../lib/context/Subscription/SubscriptionContext";
import { useAuthContext } from "../../lib/context/Auth/AuthContext";
import { tooltips } from "../../lib/utils/tooltips";

import { DevicesBox } from "../../components/Home/DevicesBox/DevicesBox";
import { InsightsBox } from "../../components/Home/InsightsBox/InsightsBox";
import { CalendarsBox } from "../../components/Home/CalendarsBox/CalendarsBox";
import { WorkplacesBox } from "../../components/Home/WorkplacesBox/WorkplacesBox";
import { SubscriptionWrapper } from "../../components/Home/SubscriptionWrapper/SubscriptionWrapper";
import { RecommendedAddOns } from "../../components/Home/RecommendedAddOns/RecommendedAddOns";
import { PageHeader } from "../../components/shared/PageHeader/PageHeader";
import { MfaReminderModal } from "./MfaReminder/MfaReminderModal";
import { UserPermissions } from "../../api/grpc/permissions/permissions";
import { Icon } from "../../components/shared/Icon/Icon";

import "./Home.scss";

export const Home = () => {
  const { isChannelPartnerAccount } = useSubscriptionContext();
  const { user } = useAuthContext();

  return (
    <div className="Home default-page">
      {user?.show2FaReminder &&
        user.permissions.includes(
          UserPermissions.PROFILE_TWO_FACTOR_AUTH_ADD
        ) && <MfaReminderModal />}
      <div>
        <PageHeader
          title="Dashboard"
          message={tooltips.dashboard.heading}
          showUserViewType={isChannelPartnerAccount}
          userViewType="Channel Partner"
        />
      </div>
      <div className="Home__boxes">
        <div className="Home__promoBanners" aria-label="GOGET resources">
          <a
            className="Home__promoBanner Home__promoBanner--news"
            href="https://gogetcorp.com/resources/news/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Read GOGET news and inspiration"
          >
            <span className="Home__promoArrow Home__promoArrow--dark">
              <Icon icon="arrow-right" />
            </span>
            <h2 className="Home__promoTitle Home__promoTitle--dark">
              News & inspiration
            </h2>
            <p className="Home__promoDescription">
              Connect & follow GOGET to stay informed, inspired, and up to date.
            </p>
            <div className="Home__promoSocials" aria-hidden="true">
              <Icon icon="linkedIn-white" />
              <Icon icon="envelope-white" />
              <Icon icon="rounded-question-mark" />
            </div>
          </a>

          <a
            className="Home__promoBanner Home__promoBanner--image Home__promoBanner--roomBooking"
            href="https://gogetcorp.com/workspace-solutions/room-booking/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Learn about GOGET room booking"
          >
            <span className="Home__promoArrow">
              <Icon icon="arrow-right" />
            </span>
            <h2 className="Home__promoTitle">New layout theme</h2>
            <span className="Home__promoTag">Room Display X</span>
          </a>

          <a
            className="Home__promoBanner Home__promoBanner--image Home__promoBanner--wayfinding"
            href="https://gogetcorp.com/workspace-solutions/workspace-wayfinding/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Learn about GOGET workspace wayfinding"
          >
            <span className="Home__promoArrow">
              <Icon icon="arrow-right" />
            </span>
            <h2 className="Home__promoTitle">3D live maps</h2>
            <span className="Home__promoTag">Wayfinding & Lobby Overview</span>
          </a>
        </div>

        <WorkplacesBox />
        <CalendarsBox />
        <DevicesBox />

        <InsightsBox />

        {/* <RecommendedAddOns /> */}

        <SubscriptionWrapper />
      </div>
    </div>
  );
};
